/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Vb365JobItemGroup } from './vb365JobItemGroup';
import { Vb365JobItemSite } from './vb365JobItemSite';
import { Vb365JobItemUser } from './vb365JobItemUser';
import { Vb365JobItemTeam } from './vb365JobItemTeam';


export interface Vb365JobItemComposed { 
    /**
     * ID assigned to a backup job item.
     */
    readonly id?: string;
    /**
     * Type of a backup job item.
     */
    itemType?: Vb365JobItemComposedItemType | null;
    /**
     * Array of folders included in a backup job.
     */
    folders?: Array<string> | null;
    /**
     * Indicates whether a backup job must include mailboxes.
     */
    backupMailbox?: boolean;
    /**
     * Indicates whether a backup job must include OneDrive data.
     */
    backupOneDrive?: boolean;
    /**
     * Indicates whether a backup job must include mailbox archive.
     */
    backupArchiveMailbox?: boolean;
    /**
     * Indicates whether a backup job must include personal sites.
     */
    backupPersonalSite?: boolean;
    /**
     * Indicates whether a backup job must include sites.
     */
    backupSites?: boolean;
    /**
     * Indicates whether a backup job must include Microsoft Teams data.
     */
    backupTeams?: boolean;
    /**
     * Indicates whether a backup job must include Microsoft Teams chat data.
     */
    backupTeamsChats?: boolean;
    /**
     * Indicates whether a backup job must include group member data.
     */
    backupMembers?: boolean;
    /**
     * Indicates whether a backup job must include group member mailboxes.
     */
    backupMemberMailbox?: boolean;
    /**
     * Indicates whether a backup job must include group member mailbox archive.
     */
    backupMemberArchiveMailbox?: boolean;
    /**
     * Indicates whether a backup job must include group member OneDrive data.
     */
    backupMemberOneDrive?: boolean;
    /**
     * Indicates whether a backup job must include group member sites.
     */
    backupMemberSite?: boolean;
    /**
     * Indicates whether a backup job must include group sites.
     */
    backupGroupSite?: boolean;
    /**
     * Site data.
     */
    site?: Vb365JobItemSite | null;
    /**
     * Microsoft Teams data.
     */
    team?: Vb365JobItemTeam | null;
    /**
     * User data.
     */
    user?: Vb365JobItemUser | null;
    /**
     * Group data.
     */
    group?: Vb365JobItemGroup | null;
}
export enum Vb365JobItemComposedItemType {
    Unknown = 'Unknown',
    Group = 'Group',
    User = 'User',
    Site = 'Site',
    PartialOrganization = 'PartialOrganization',
    PersonalSites = 'PersonalSites',
    OneDriveFolders = 'OneDriveFolders',
    Team = 'Team'
};



